<section class="pt-16 pb-8 px-container">    
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Spettacoli', route: '/backoffice/spettacoli/' }, { label: 'Aggiungi Spettacolo', route: '/backoffice/spettacoli/add' }]"></app-breadcrumb-backoffice>
    <h1 class="lg:text-4xl text-2xl font-mono text-center uppercase">AGGIUNGI SPETTACOLO</h1>    
</section>


<section class="pb-16 mb-8 px-container">    
    
    <!-- TABS -->
    <div class="text-center">
        <ul class="flex flex-wrap -mb-[2px] divide-x">
            <li class="pe-2">
                <span class="tab" (click)="section = 'info'" [ngClass]="{'tab-active': section == 'info'}">INFO</span>
            </li>
            <li class="px-2">
                <span class="tab" (click)="section = 'cast'" [ngClass]="{'tab-active': section == 'cast'}">CAST</span>
            </li>
            <li class="px-2">
                <span class="tab" (click)="section = 'prezzi'" [ngClass]="{'tab-active': section == 'prezzi'}">PREZZI</span>
            </li>
            <li class="px-2">
                <span class="tab" (click)="section = 'immagini'" [ngClass]="{'tab-active': section == 'immagini'}">IMMAGINI</span>
            </li>            
        </ul>
    </div>
    <!-- TABS -->

    <!-- FORM -->
    <form [formGroup]="formSpettacolo" (ngSubmit)="onSubmit()">

        <div class="flex flex-col gap-8">

            <!-- INFO -->            
            <ng-container *ngIf="section == 'info'">       
                <p class="uppercase text-xl pt-8 border-t">INFO</p>

                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="lg:w-1/2 w-full">
                        <label>* Spettacolo</label>
                        <input type="text" pInputText placeholder="Spettacolo" formControlName="spettacolo" required />
                        <small class="text-red-600 block mt-4 font-medium" *ngIf="formSpettacolo.get('spettacolo')?.hasError('required') && (formSpettacolo.get('spettacolo')?.dirty || formSpettacolo.get('spettacolo')?.touched)">Lo spettacolo è obbligatorio!.</small>
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>Compagnia</label>
                        <input type="text" pInputText placeholder="Compagnia" formControlName="compagnia" />
                    </div>
                </div>

                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="w-full">
                        <label>Descrizione</label>
                        <p-editor [style]="{ height: '150px' }" formControlName="descrizione" />
                    </div>
                </div>

                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="w-full">
                        <label>* Data</label>
                        <p-calendar formControlName="dal_al" placeholder="Data Dal - Al" dateFormat="dd/mm/yy" [showIcon]="true"  selectionMode="range" [minDate]="minDate" />
                        <small class="text-red-600 block mt-4 font medium" *ngIf="formSpettacolo.get('dal_al')?.hasError('required') && (formSpettacolo.get('dal_al')?.dirty || formSpettacolo.get('dal_al')?.touched)"> Inserire una data valida</small>
                    </div>
                </div>

                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="lg:w-1/2 w-full">
                        <label>Vendita Dal</label>
                        <p-calendar formControlName="prenotabile_dal" placeholder="Vendita Dal" dateFormat="dd/mm/yy" [showIcon]="true" [minDate]="minDate" />
                        <small class="text-red-600 block mt-4 font medium" *ngIf="!formSpettacolo.get('prenotabile_dal')?.valid && formSpettacolo.get('prenotabile_dal')?.touched"> Inserire una data valida</small>
                    </div>
                    <div class="lg:w-1/2 w-full">
                        <label>Orario Vendita Dal</label>
                        <p-calendar placeholder="Orario Vendita Dal" formControlName="prenotabile_dal_orario" [timeOnly]="true" [showIcon]="true" />
                    </div>
                </div>
            </ng-container>
            <!-- INFO -->            
            
            <!-- IMPOSTAZIONI -->
            <div class="flex flex-col gap-8 border-t pt-8" *ngIf="section == 'info'">                

                <div class="flex lg:flex-row flex-col gap-8 ">
                    <div class="flex flex-col lg:w-1/3 w-full gap-y-3 items-center">
                        <div class="w-full">
                            <p-checkbox label="Online" formControlName="online" value="online" pTooltip="Se selezionato, lo spettacolo sarà visibile ai clienti!" tooltipPosition="top" />
                        </div>
                        <div class="w-full">
                            <p-checkbox label="Evidenzia" formControlName="evidenzia" value="evidenzia" pTooltip="Se selezionato, lo spettacolo apparirà in home page! In caso sia presente un video verrà mostrato al posto dell'immagine di copertina" tooltipPosition="top" />
                        </div>
                        <div class="w-full">
                            <p-checkbox label="Gratuito" formControlName="gratuito" value="gratuito" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'PRENOTA SUBITO'" tooltipPosition="top" />
                        </div>
                    </div>
                    <div class="flex flex-col lg:w-1/3 w-full gap-y-3 items-center">
                        <div class="flex lg:flex-row flex-col justify-start w-full items-center">
                            <div class="w-full" [ngClass]="{'lg:w-1/2' : formSpettacolo.get('in_vendita_dal')?.value && formSpettacolo.get('in_vendita_dal')?.value.length > 0 }">
                                <p-checkbox label="In vendita dal" formControlName="in_vendita_dal" value="in_vendita_dal" (ngModelChange)="onInVenditaDal($event)" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'IN VENDITA DAL + DATA INSERITA' e non sarà cliccabile" tooltipPosition="top" />
                            </div>
                            <div class="lg:w-1/2 w-full" *ngIf="formSpettacolo.get('in_vendita_dal')?.value && formSpettacolo.get('in_vendita_dal')?.value.length > 0">
                                <label>* Data in vendita dal</label>
                                <p-calendar formControlName="in_vendita_dal_data" placeholder="Data in vendita dal" dateFormat="dd/mm/yy" [minDate]="minDate" [showIcon]="true" />
                                <small class="text-red-600 block mt-4 font medium" *ngIf="formSpettacolo.get('in_vendita_dal_data')?.hasError('required') && (formSpettacolo.get('in_vendita_dal_data')?.dirty || formSpettacolo.get('in_vendita_dal_data')?.touched)"> Inserire una data valida</small>
                            </div>
                        </div>
                        <div class="w-full">
                            <p-checkbox label="A breve in vendita" formControlName="soon_in_vendita" value="soon_in_vendita" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'A BREVE IN VENDITA' e non sarà cliccabile" tooltipPosition="top"  />
                        </div>
                        <div class="w-full">
                            <p-checkbox label="Sold Out" formControlName="sold_out" value="sold_out" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'SOLD OUT' e non sarà cliccabile" tooltipPosition="top"  />
                        </div>
                        <div class="w-full">
                            <p-checkbox label="Annullato" formControlName="annullato" value="annullato" pTooltip="Se selezionato, il pulsante di acquisto delle spettacolo apparirà con il testo 'ANNULLATO' e non sarà cliccabile" tooltipPosition="top"   />
                        </div>
                    </div>
                    <div class="flex flex-col lg:w-1/3 w-full gap-y-3 items-center">
                        <div class="w-full">
                            <p-checkbox label="Web Shop" formControlName="webshop" value="webshop" (ngModelChange)="onCheckBox($event, 'webshop')" pTooltip="Se selezionato, al pulsante d'acquisto verrà associato il link inserito nel campo 'Link Webshop'" tooltipPosition="top"  />
                        </div>
                        <div class="w-full">
                            <p-checkbox label="Custom" formControlName="custom" value="custom" (ngModelChange)="onCheckBox($event, 'custom')" pTooltip="Se selezionato, al pulsante d'acquisto verrà associato il link inserito nel campo 'Link Custom'" tooltipPosition="top" />
                        </div>                        
                    </div>
                </div>
            </div>
            <!-- IMPOSTAZIONI -->

            <!-- LINK SHOPS -->
            <ng-container *ngIf="section == 'info'">
                <!-- WEBSHOP -->
                <div class="flex flex-col gap-8 border-t pt-8" *ngIf="webshop">
                    <p class="uppercase text-xl">WEB SHOP</p>

                    <div class="w-full">
                        <label>Link Web Shop</label>
                        <input type="text" pInputText formControlName="link_webshop" />
                    </div>

                </div>
                <!-- WEBSHOP -->

                <!-- CUSTOM -->
                <div class="flex flex-col gap-8 border-t pt-8" *ngIf="custom">

                    <p class="uppercase text-xl">CUSTOM</p>

                    <div class="w-full">
                        <label>Link Custom</label>
                        <input type="text" pInputText formControlName="link_custom" />
                    </div>
                </div>
                <!-- CUSTOM -->

            </ng-container>
            <!-- LINK SHOPS -->

            <!-- CAST -->
            <div class="flex flex-col gap-8 border-t pt-8" *ngIf="section == 'cast'">                
                <p class="uppercase text-xl">Cast</p>
                <app-cast-spettacolo-backoffice [casts]="casts" (data)="onCastSpettacolo($event)"></app-cast-spettacolo-backoffice>
            </div>
            <!-- CAST -->

            <!-- PREZZI -->
            <div class="flex flex-col gap-8 border-t pt-8" *ngIf="section == 'prezzi'">
                <p class="uppercase text-xl">Prezzi</p>

                <app-prezzi-spettacolo-backoffice [prezzi]="prezzi" (data)="onPrezziSpettacolo($event)"></app-prezzi-spettacolo-backoffice>

                <div class="flex lg:flex-row flex-col gap-8">
                    <div class="w-full">
                        <label>Descrizione prezzi</label>
                        <p-editor [style]="{ height: '150px' }" formControlName="descrizione_prezzi" />
                    </div>
                </div>
            </div>
            <!-- PREZZI -->

            <!-- BOX E COVEER -->
            <div class="flex flex-col gap-8 border-t py-8" *ngIf="section == 'immagini'">
                <p class="uppercase text-xl">IMMAGINI</p>
            
                <app-immagini-spettacolo-backoffice (ritaglio)="onImmaginiSpettacolo($event)"></app-immagini-spettacolo-backoffice>
            </div>
            <!-- BOX E COVER -->

            <button class="btn-outln-backoffice p-3 w-full font-medium" type="submit" [disabled]="!formSpettacolo.valid">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="animate-spin w-5 inline me-2 fill-accent" *ngIf="loading"><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z"/></svg>
                Aggiungi spettacolo
            </button>
        </div>
    </form>
    <!-- FORM -->
    
</section>